export const myAccountStateKey = 'myAccount';
export const customerOrderStateKey = 'order';
export const customerSubscriptionStateKey = 'subscription';
export const subscriptionChangeStateKey = 'subscriptionChange';
export const refundRequestStateKey = 'refundRequest';
